Ext.define('SA.model.map.ExportTextOverlay', {
    extend: 'Ext.data.Model',
    mixins: ['SA.model.ObservableChangeMixin'],

    fields: [
        {name: 'x', type: 'proportion'},
        {name: 'y', type: 'proportion'},

        'text',

        'typeface',

        'size',

        'color',
        'background',

        'bold',
        'italic',
        'underline'
    ],

    getBackground() {
        return this.get('background');
    },

    getColor() {
        return this.get('color');
    },

    getSize() {
        return this.get('size');
    },

    getSizeInPixels(dpi) {
        return this.getSize() / 72 * dpi;
    },

    getText() {
        return this.get('text');
    },

    getTypeface() {
        return this.get('typeface');
    },

    getX() {
        return this.get('x');
    },

    getY() {
        return this.get('y');
    },

    isBold() {
        return this.get('bold');
    },

    isItalic() {
        return this.get('italic');
    },

    isUnderline() {
        return this.get('underline');
    },

    setBackground(background) {
        this.setWithEvent('background', background);
    },

    setDimensions(values) {
        this.setWithEvent(values, 'set:dimensions');
    },

    setColor(color) {
        this.setWithEvent('color', color);
    },

    setSize(size) {
        this.setWithEvent('size', size);
    },

    setStyle(style, value) {
        this.setWithEvent(SA.createObject(style, value), 'set:style');
    },

    setText(text) {
        this.setWithEvent('text', text);
    },

    setTypeface(typeface) {
        this.setWithEvent('typeface', typeface);
    },

    toData() {
        var background = this.getBackground();

        return {
            background,
            backgroundOpacity: background === '' ? 0 : 1,
            fill: this.getColor(),
            fontFamily: this.getTypeface(),
            fontSize: this.getSize(),
            fontStyle: this.isItalic() ? 'italic' : 'normal',
            fontWeight: this.isBold() ? 'bold' : 'normal',
            text: this.getText(),
            x: this.getX(),
            y: this.getY()
        };
    }
});